import { useProjectCostContext } from '../ProjectsCostManagement';

export function useTypedProjectCostContext<T>(): T {
  return useProjectCostContext() as T;
}
